import get, { post } from './client'
import type { ApiResponse } from './types'

export interface User {
  user_id: string
  phone_country_code: string
  phone_number: string
  username: string
  is_active?: boolean
  created_at?: string
}

export interface RsaPublicKey {
  public_key: string
  key_id: string
  expires_in: number
}

export interface LoginResponse {
  token: string
  expires_in: number
  expires_at: string
  auto_login: boolean
  user: User
}

export interface SendSmsCodePayload {
  phone_country_code: string
  phone_number: string
}

export interface RegisterPayload {
  phone_country_code: string
  phone_number: string
  username: string
  encrypted_password: string
  key_id: string
  sms_code: string
}

export interface LoginPayload {
  phone_country_code: string
  phone_number: string
  encrypted_password: string
  key_id: string
  auto_login: boolean
}

// 后端统一用 { code, msg, data } 包装成功响应（见 novus-api 的 Response.ok），
// 与 api/discover.ts 一致，这里解包 data 再返回裸 DTO。
// 注意：若不解包，rsaPublicKey 的 public_key/key_id 会变成 undefined，
// 进而导致 login/register 请求体缺 key_id，被后端校验拒为 "Invalid request parameters"。
const unwrap = <T>(res: ApiResponse<T>): T => res.data as T

export const authApi = {
  rsaPublicKey: async () => unwrap(await get<ApiResponse<RsaPublicKey>>('/auth/rsa-public-key')),
  sendSmsCode: async (payload: SendSmsCodePayload) =>
    unwrap(await post<ApiResponse<{ message: string; expires_in: number }>>('/auth/send-sms-code', payload)),
  register: async (payload: RegisterPayload) => unwrap(await post<ApiResponse<User>>('/auth/register', payload)),
  login: async (payload: LoginPayload) => unwrap(await post<ApiResponse<LoginResponse>>('/auth/login', payload)),
  autoLogin: async (token: string) => unwrap(await post<ApiResponse<LoginResponse>>('/auth/auto-login', { token })),
  logout: async () => unwrap(await post<ApiResponse<{ message: string }>>('/auth/logout', {})),
  me: async () => unwrap(await get<ApiResponse<User>>('/auth/me')),
}
